import React, { useRef } from "react";
import { createPortal } from "react-dom";
import { CSSTransition } from "react-transition-group";
import { useClickOutsideListener } from "../../hooks/useClickOutsideListener";

import { Alignments, usePositionAt } from "./hooks/usePositionAt";
import * as css from "./styles";

type Props = {
  children?: React.ReactNode;
  active: boolean;
  pointAtRef: React.RefObject<HTMLElement | null>;
  offsetTopPx?: number;
  alignment: Alignments;
  containerRef?: React.RefObject<HTMLElement | null>;

  onClose(): void;
};

export const Dropdown: React.FC<Props> = ({
  children,
  active,
  pointAtRef,
  offsetTopPx = 0,
  containerRef,
  alignment,
  onClose,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const pos = usePositionAt({
    pointAtRef,
    containerRef,
    alignment,
    offsetTopPx,
  });
  useClickOutsideListener(onClose, dropdownRef);

  return createPortal(
    <CSSTransition
      in={active}
      timeout={css.TRANSITION_DURATION_MS}
      classNames={css.dropdownCls}
      mountOnEnter
      unmountOnExit
      nodeRef={dropdownRef}
    >
      <div className={css.dropdownCls} style={pos} ref={dropdownRef}>
        <div className={css.arrowCls} role="presentation" />
        {children}
      </div>
    </CSSTransition>,
    containerRef?.current ?? document.body
  );
};
